import React from 'react';
import { Helmet } from 'react-helmet-async';
import suburbs from '@/data/suburbs.json';

interface ServiceSchemaProps {
  serviceName: string;
  description: string;
  priceFromAUD?: number;
  url: string;
  areaServed?: string[];
}

const SITE_BASE = 'https://y3smilesdental.com.au';

export const ServiceSchema: React.FC<ServiceSchemaProps> = ({
  serviceName,
  description,
  priceFromAUD,
  url,
  areaServed,
}) => {
  const areas =
    areaServed ??
    (suburbs as Array<{ name: string }>).map((s) => s.name);
  const data: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'MedicalProcedure',
    name: serviceName,
    description,
    url,
    provider: {
      '@type': 'Dentist',
      name: 'Y3 Smiles Dental',
      url: SITE_BASE,
      telephone: '+61390224442',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Unit 1, 34 King William St',
        addressLocality: 'Broadmeadows',
        addressRegion: 'VIC',
        postalCode: '3047',
        addressCountry: 'AU',
      },
    },
    areaServed: areas.map((s) => ({ '@type': 'City', name: s })),
  };
  if (typeof priceFromAUD === 'number') {
    data.offers = {
      '@type': 'Offer',
      priceCurrency: 'AUD',
      price: String(priceFromAUD),
      url,
    };
  }
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default ServiceSchema;